module.exports = __webpack_public_path__ + "static/media/arrow-to-right.ba0f7d49.svg";